import ManualTax from "../../components/ModalTaxInformation/ManualTax.vue";

import ServiceTax from "../../services/serviceTax";
import ServiceCategoriasRef from "../../services/serviceCategoriasRef";
import toastAlertErros from "../../utils/toastAlertErros";
import HandleTaxNotaFIscal from "../../utils/handleTaxData"
import { initialStateInfoFiscal, initialStateTaxForSelectBoxes, initialStateObjectIcms } from "../../initialStates/infoFiscal"
import handleTaxData from "../../utils/handleTaxData";

const mixinModalTaxInformations = {
  props: {
    refFromSearch: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      infoFiscal: JSON.parse(JSON.stringify(initialStateInfoFiscal)),
      taxForSelectBoxes: JSON.parse(JSON.stringify(initialStateTaxForSelectBoxes)),
      enableISSQN: true,
      enableBeneficioFiscal: false,
      objectIcms: JSON.parse(JSON.stringify(initialStateObjectIcms)),
      createdNewRef: false,
      openModalTax: false,
      activeCtn: false,
      generalSpin: false,
      refsFiscais: [],
      categoriasRef: [],
      nomeCategoria: "",
      categoriaEditando: null,
      tabs: [
        { name: "geral", text: "Geral" },
        { name: "ICMS", text: "ICMS" },
        { name: "IPI", text: "IPI" },
        { name: "PIS", text: "PIS" },
        { name: "COFINS", text: "COFINS" },
        { name: "ISSQN", text: "ISSQN" },
        { name: "IBS_CBS", text: "IBS/CBS" },
        { name: "info", text: "Informações" },
        { name: "imposto_manual", text: "Imposto Manual" },
      ],
      tabSelected: 0,
    };
  },
  components: {
    ManualTax
  },
  methods: {
    async save() {
      try {
        this.generalSpin = true;

        const adjustedTaxObject = HandleTaxNotaFIscal.handleValues(this.infoFiscal.refObject, this.objectIcms)

        if (this.enableISSQN) {
          delete adjustedTaxObject.issqn;
        }

        this.infoFiscal.refObject = adjustedTaxObject;

        const result = await ServiceTax.save(this.infoFiscal);
        this.infoFiscal.id = result.id;

        await this.findAllRefs()
        this.clear()
        this.findAllRefsFromSelectBox()

        return this.$toast.open({
          message: "REF gerado com sucesso!",
          type: "success",
        });
      } catch (error) {
        if (error.response.data.erros.length > 0) {
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        } else {
          return toastAlertErros.validateMessage(error, this.$toast);
        }
      } finally {
        this.generalSpin = false;
      }
    },
    async update() {
      try {
        this.generalSpin = true;
        const adjustedTaxObject = HandleTaxNotaFIscal.handleValues(this.infoFiscal.refObject, this.objectIcms)

        if (this.enableISSQN) {
          delete adjustedTaxObject.issqn;
        }

        await ServiceTax.update({ ...this.infoFiscal, refObject: adjustedTaxObject })
        await this.findAllRefs()
        return this.$toast.open({
          message: "REF atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message: error.response.data.message,
          type: "error",
        });
      } finally {
        this.generalSpin = false;
      }
    },
    async deleteTax(dataRef) {
      try {
        await ServiceTax.delete(dataRef)
        await this.findAllRefs()
        this.findAllRefsFromSelectBox()

        return this.$toast.open({
          message: "REF deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message: error.response.data.message,
          type: "error",
        });
      }
    },
    async edit(id) {
      try {
        const result = await ServiceTax.findById(id)
        this.enableISSQN = result.refObject.issqn ? false : true

        const newInfoFiscal = HandleTaxNotaFIscal.handleTaxFromEdit(this.infoFiscal.refObject, result)
        this.infoFiscal = { ...result, refObject: newInfoFiscal }

        this.$bvModal.hide("modal-center");
      } catch (error) {
        console.log(error)
        return this.$toast.open({
          message: error.response.data,
          type: "error",
        });
      }
    },
    async findByRefName(refName) {
      try {
        const result = await ServiceTax.findByRefName(refName)
        this.enableISSQN = result.refObject.issqn ? false : true

        const newInfoFiscal = HandleTaxNotaFIscal.handleTaxFromEdit(this.infoFiscal.refObject, result)
        this.infoFiscal = { ...result, refObject: newInfoFiscal }

        this.$bvModal.hide("modal-center");
      } catch (error) {
        return this.$toast.open({
          message: error.response.data,
          type: "error",
        });
      }
    },
    async findAllRefs() {
      try {
        const result = await ServiceTax.findAllRefs();
        this.refsFiscais = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async findCategoriasRef() {
      try {
        this.categoriasRef = await ServiceCategoriasRef.findAll();
      } catch (error) {
        this.showCategoryError(error);
      }
    },
    async saveCategoriaRef() {
      if (!this.nomeCategoria.trim()) return;

      try {
        if (this.categoriaEditando) {
          await ServiceCategoriasRef.update(this.categoriaEditando, this.nomeCategoria.trim());
        } else {
          await ServiceCategoriasRef.save(this.nomeCategoria.trim());
        }

        this.categoriaEditando = null;
        this.nomeCategoria = "";

        await this.findCategoriasRef();
        await this.findAllRefs();
      } catch (error) {
        this.showCategoryError(error);
      }
    },
    async deleteCategoriaRef(id) {
      try {
        await ServiceCategoriasRef.delete(id);
        await this.findCategoriasRef();
      } catch (error) {
        this.showCategoryError(error);
      }
    },
    showCategoryError(error) {
      this.$toast.open({ message: error.response?.data?.message || "Erro ao gerenciar categorias", type: "error" });
    },
    async duplicate(id) {
      try {
        await this.edit(id)

        this.infoFiscal.id = ""
      } catch (error) {
        console.log(error)
        return this.$toast.open({
          message: error.response.data,
          type: "error",
        });
      }
    },
    closeModal() {
      this.clear()
      this.$emit('closeModal')
      this.$bvModal.hide('modalTaxInformation')
    },
    findAllRefsFromSelectBox() {
      this.$emit('createdNewRef', this.createdNewRef = !this.createdNewRef)
    },
    handleSaveOrUpdate() {
      this.infoFiscal.imposto_manual = this.$refs.manualTaxComponent?.infoFiscal

      this.infoFiscal.id !== "" ? this.update() : this.save();
    },
    handleChangeIssqn() {
      this.enableISSQN = !this.enableISSQN;
    },
    clear() {
      this.infoFiscal = handleTaxData.clearTax()
      this.enableISSQN = true;
    },
    activeISSQN() {
      this.activeCtn = !this.activeCtn
    },
  },
  computed: {
    opcoesClassificacao() {
      const situacao = this.infoFiscal.refObject.ibs_cbs[0].situacao_tributaria;
      const chaveOpcoes = `sit${situacao}`;
      return this.taxForSelectBoxes.ibs_cbs[chaveOpcoes] || [];
    },
    opcoesClassificacaoRegular() {
      const situacao = this.infoFiscal.refObject.ibs_cbs[0].situacao_tributaria_regular;
      const chaveOpcoes = `sit${situacao}`;
      return this.taxForSelectBoxes.ibs_cbs[chaveOpcoes] || [];
    },
    isManualTax() {
      return this.infoFiscal.flags.isManual
    }
  },
  watch: {
    opcoesClassificacao(novasOpcoes) {
      if (novasOpcoes && novasOpcoes.length > 0) {
        this.infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria = novasOpcoes[0].value;
      } else {
        this.infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria = null;
      }
    },
    opcoesClassificacaoRegular(novasOpcoes) {
      if (novasOpcoes && novasOpcoes.length > 0) {
        this.infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria_regular = novasOpcoes[0].value;
      } else {
        this.infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria_regular = null;
      }
    },
    isManualTax() {
      this.$nextTick(() => {
        if (this.$refs.manualTaxComponent)
          this.$refs.manualTaxComponent.infoFiscal = this.infoFiscal.imposto_manual
      })
    },
    refFromSearch() {
      if (this.refFromSearch) this.findByRefName(this.refFromSearch)
    }
  },
  created() {
    this.generalSpin = false
  },
  mounted() {
    this.findAllRefs()
    this.findCategoriasRef()
    this.generalSpin = false
  }
}

export default mixinModalTaxInformations;
